import { AirplaneClockIcon } from './AirplaneClockIcon';

/**
 * author: Colton Wiscombe
 * id 8C33AFFF-209E-41AC-A403-B1A46B321917
 * name airplane-clock
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-clock.svg
 * tags
 * - Transportation + Flying 
 * - Date / Time 
 */
export const AirplaneScheduleIcon = AirplaneClockIcon;
export default AirplaneScheduleIcon